/**
 * Enum for the switch view dropdown in the left nav
 */ export var NavView = /*#__PURE__*/ function(NavView) {
    /** Tasks view */ NavView["TasksView"] = "tasksView";
    /** Publisher view */ NavView["PublisherView"] = "publisherView";
    return NavView;
}({});
/**
 * Enumeration of the static options for LeftNav
 */ export var LeftNavStaticOptions = /*#__PURE__*/ function(LeftNavStaticOptions) {
    /** The my day view */ LeftNavStaticOptions["MyDay"] = "myDay";
    /** The plan hub view */ LeftNavStaticOptions["MyPlans"] = "myPlans";
    /** The my tasks view */ LeftNavStaticOptions["MyTasks"] = "myTasks";
    /** The my portfolios view */ LeftNavStaticOptions["MyPortfolios"] = "myPortfolios";
    return LeftNavStaticOptions;
}({});
